import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ClientSessionService } from './client-session.service';
import { NotificationService } from './notification.service';

@Injectable()
export class EditProjectAccessGuard implements CanActivate {
  constructor(
    private clientSessionService: ClientSessionService,
    private notificationService: NotificationService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isProjectManager = this.clientSessionService.isInRoleName('Project Manager');
    if (isProjectManager) {
      this.notificationService.warning('Access Denied', 'Project Managers are not allowed to edit projects.');
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
